<template>
  <section class="section">
    <div class="container formula__inner">
      <div class="formula__content">
        <span class="section__label">Прозрачность</span>
        <h2 class="section__title">Формула как в Положении о&nbsp;премировании</h2>
        <p class="section__subtitle formula__subtitle">
          Вы видите не таблицу с числами, а саму формулу. Один и тот же расчёт — в двух видах:
          математическая запись для документов и расшифровка с подставленными числами для сотрудника.
        </p>
        <ul class="formula__list">
          <li>Математическая запись попадает прямо в Положение о премировании</li>
          <li>Расшифровка с числами — снимает споры по начислениям</li>
          <li>Премия не уходит в минус, а руководитель может скорректировать её коэффициентом в заданных границах</li>
          <li>Коэффициент KPI-карты подставляется в формулу — премия растёт вместе с выполнением показателей</li>
          <li>Изменили формулу — изменилась и запись, расхождений нет</li>
        </ul>
      </div>
      <div class="formula__visual">
        <div class="formula__card">
          <div class="formula__card-label">Формула: премия продавца самолётов</div>
          <div class="formula__expr">
            Премия = max(0; Самолёты × 10% + Допоборудование × 30% − Оклад) × К<sub>жалоб</sub> × К<sub>руководителя</sub>
          </div>
          <div class="formula__card-label">Расчёт сотрудника</div>
          <div class="formula__expr formula__expr--values">
            = max(0; 145 000 + 126 000 − 53 929) × 0,8 × 1,2 = <strong>208 389 ₽</strong>
          </div>
          <div class="formula__card-footer">
            <span class="formula__check">✓</span> Сотрудник видит этот расчёт в личном кабинете
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FormulaSection',
}
</script>

<style scoped>
.formula__inner {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 64px;
  align-items: center;
}
.formula__subtitle { margin-bottom: 24px; }
.formula__list {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.formula__list li {
  color: var(--gray);
  font-size: 0.9375rem;
  padding-left: 24px;
  position: relative;
  line-height: 1.6;
}
.formula__list li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: var(--secondary);
  font-weight: 700;
}
.formula__card {
  background: white;
  border: 1px solid var(--border);
  border-radius: 16px;
  padding: 32px;
  box-shadow: var(--shadow);
}
.formula__card-label {
  font-size: 0.8125rem;
  color: var(--gray);
  font-weight: 500;
  margin-bottom: 8px;
}
.formula__expr {
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--dark);
  line-height: 1.6;
  margin-bottom: 24px;
}
.formula__expr--values {
  color: var(--primary);
  margin-bottom: 20px;
}
.formula__frac { white-space: nowrap; }
.formula__card-footer {
  border-top: 1px solid var(--border);
  padding-top: 16px;
  font-size: 0.875rem;
  color: var(--gray);
  display: flex;
  align-items: center;
  gap: 8px;
}
.formula__check { color: var(--secondary); font-weight: 700; }

@media (max-width: 900px) {
  .formula__inner { grid-template-columns: 1fr; gap: 40px; }
}
</style>
